export const SVG_HIDDEN_ELEMENT_OPACITY = 0.4;
